function cleanupLinks(HTML) {
    //for each link, make sure the target is set to _blank, and make sure the href starts with https://
    const parser = new DOMParser();
    const doc = parser.parseFromString(HTML, 'text/html');
    doc.querySelectorAll('a').forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');

        const href = link.getAttribute('href');
        if (!href.startsWith('http')) {
            link.setAttribute('href', 'https://' + href);
        }
    });
    return doc.body.innerHTML;
}

const quillModules = {
    toolbar: [
        [{ 'header': [1, 2, false] }],
        [
            'bold',
            'italic',
            'underline',
            'strike',
            {'list': 'ordered'},
            {'list': 'bullet'},
            {'align': []},
            'link',
            'clean'
        ]
    ],
};

export { cleanupLinks, quillModules };